import { appStore } from '../store/store';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';

const LAST_ACTIVITY_TIMESTAMP = 'lastActivityTimestamp';
const LAST_ACTIVITY_TAB_ID = 'lastActivityTabId'; // Unique identifier for tabs

export const initializeInactivityTimeout = (showWarning, hideWarning) => {
  const warningTime = 1000 * 60 * 40; // 40 minutes
  const logoutTime = 1000 * 60 * 5; // 5 minutes after warning
  const events = ['mousemove', 'keydown', 'touchstart', 'scroll', 'click'];

  let timer = null;
  let logoutTimer = null;

  const resetTimer = () => {
    const now = Date.now();
    localStorage.setItem(LAST_ACTIVITY_TIMESTAMP, now.toString());
    localStorage.setItem(LAST_ACTIVITY_TAB_ID, `${Date.now()}-${Math.random()}`); // Update the tab ID
    hideWarning();
    clearTimeout(timer);
    clearTimeout(logoutTimer);
    timer = setTimeout(checkInactivity, warningTime);
  }

  const checkInactivity = () => {
    const now = Date.now();
    const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_TIMESTAMP), 10);
    const timeSinceLastActivity = now - lastActivity;
    if (timeSinceLastActivity >= warningTime) {
      showWarning();
      logoutTimer = setTimeout(() => {
        appStore.logout();
        localStorage.removeItem(LAST_ACTIVITY_TIMESTAMP);
        localStorage.removeItem(LAST_ACTIVITY_TAB_ID);
        hideWarning();
      }, logoutTime);
    }
    else resetTimer();
  }

  const debouncedReset = debounce(resetTimer, 1000);
  const throttledReset = throttle(resetTimer, 3000);

  const onStorageChange = (e) => {
    if (e.key === LAST_ACTIVITY_TIMESTAMP) {
      const lastActivityTabId = localStorage.getItem(LAST_ACTIVITY_TAB_ID);
      if (lastActivityTabId !== `${Date.now()}-${Math.random()}`) {
        // Means another tab has activity. Only reset the timer if the change came from another tab
        resetTimer();
      }
    }
  }
  const throttledStorageChange = throttle(onStorageChange, 3000);

  const setup = () => {
    resetTimer();
    events.forEach(event => {
      if (event === 'mousemove') window.addEventListener(event, throttledReset);
      else window.addEventListener(event, debouncedReset);
    })
    window.addEventListener('storage', throttledStorageChange);
  }

  const cleanup = () => {
    clearTimeout(timer);
    clearTimeout(logoutTimer);
    events.forEach(event => {
      if (event === 'mousemove') window.removeEventListener(event, throttledReset);
      else window.removeEventListener(event, debouncedReset);
    });
    window.removeEventListener('storage', throttledStorageChange);
  }
  return { setup, cleanup }
}